import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/services/theme.service';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent implements OnInit {
  @Input() height = 108.73856590401749;
  @Input() width = 369.6666666666667;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {}

  get theme() {
    return this.themeService.getTheme();
  }
}
